// extracted by mini-css-extract-plugin
export default {"priceWrapper":"_5d58ae21","pillWrapper":"_f0814fb5","paddle":"_fb13fc67"};